<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vs-tabs
          alignment="fixed"
          class="tab-action-btn-fill-conatiner"
          v-model="activeTab"
        >
          <vs-tab :label="$t('setup.label.Properties')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                v-if="propertyListData && propertyListData.pageItems"
                :data="propertyListData.pageItems"
                :description="false"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("setup.label.DetailsOfProperty") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="editJobsUomPopup = true"
                      size="small"
                      >{{ $t("setup.label.PropertyDataUpload") }}</vs-button
                    >
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push({ name: 'Create Property' })"
                      size="small"
                      >{{ $t("setup.label.CreateProperty") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("setup.label.PropertyCode") }}</vs-th>
                  <vs-th>{{ $t("setup.label.PropertyType") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Parcel") }}</vs-th>
                  <vs-th>{{ $t("setup.label.BuildingCode") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Precinct") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Allocated") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("setup.label.Actions")
                  }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="data"
                    v-for="(Property, index) in data"
                  >
                    <vs-td :data="Property.propertyCode">{{
                      Property.propertyCode
                    }}</vs-td>
                    <vs-td :data="Property.propertyType">{{
                      Property.propertyType
                    }}</vs-td>

                    <vs-td :data="Property.parcel">{{ Property.parcel }}</vs-td>
                    <vs-td :data="Property.buildingCode">{{
                      Property.buildingCode
                    }}</vs-td>

                    <vs-td :data="Property.precinct">{{
                      Property.precinct
                    }}</vs-td>
                    <vs-td :data="Property.status">{{ Property.status }}</vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EyeIcon"
                          :title="$t('setup.label.View')"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor"
                          @click.stop="
                            $router.push({
                              name: 'View Property',
                              params: { id: Property.id },
                            })
                          "
                          class="icon_row"
                        />
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('setup.label.Edit')"
                          svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                          @click.stop="
                            $router.push({
                              name: 'Edit Property',
                              params: { id: Property.id },
                            })
                          "
                          class="icon_row"
                        />
                        <feather-icon
                          icon="TrashIcon"
                          :title="$t('setup.label.Delete')"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor"
                          @click.stop="
                            deletePropertyPopup = true;
                            delId = Property.id;
                          "
                          class="icon_row"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="centerx">
                <vs-popup
                  classContent="popup-example"
                  :title="$t('setup.label.UploadPropertyData')"
                  :active.sync="editJobsUomPopup"
                  class="popup-close"
                >
                  <div class="vx-row w-full mb-6">
                    <div class="vx-col mb-2 mt-5 w-full form__container">
                      <label class="upload-label">
                        <img
                          src="@/assets/images/icons/Upload.svg"
                          alt="Upload Icon"
                          class="upload-icon"
                        />
                        <div class="upload-text">{{$t("setup.label.Browse_file_to_Upload")}}</div>
                      </label>
                    </div>
                  </div>
                  <div class="vx-row button-container">
                    <span class="button-spacing">
                      <vs-button
                        type="border"
                        @click="editJobsUomPopup = false"
                      >
                        {{ $t("setup.label.Cancel") }}
                      </vs-button>
                    </span>
                    <span class="button-spacing">
                      <vs-button @click="addUploadFile()">
                        {{ $t("setup.label.Save") }}
                      </vs-button>
                    </span>
                  </div>
                </vs-popup>
              </div>
            </vx-card>
          </vs-tab>

          <vs-tab :label="$t('setup.label.PropertyMaster')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                v-if="
                  propertyMasterListData && propertyMasterListData.pageItems
                "
                :data="propertyMasterListData.pageItems"
                :description="false"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("setup.label.PropertyMaster") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="editPropertyMasterPopup = true"
                      size="small"
                      >{{ $t("setup.label.PropertyDataUpload") }}</vs-button
                    >
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push({ name: 'Create Property Master' })"
                      size="small"
                      >{{ $t("setup.label.CreatePropertyMaster") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("setup.label.PropertyType") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Code") }}</vs-th>
                  <vs-th>{{ $t("setup.label.CodeDescription") }}</vs-th>
                  <vs-th>{{ $t("setup.label.ReferenceValue") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("setup.label.Action")
                  }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="data"
                    v-for="(PropertyMaster, index) in data"
                  >
                    <vs-td :data="PropertyMaster.propertyCodeType">{{
                      PropertyMaster.propertyCodeType
                    }}</vs-td>
                    <vs-td :data="PropertyMaster.code">{{
                      PropertyMaster.code
                    }}</vs-td>
                    <vs-td :data="PropertyMaster.description">{{
                      PropertyMaster.description
                    }}</vs-td>
                    <vs-td :data="PropertyMaster.referenceValue">{{
                      PropertyMaster.referenceValue
                    }}</vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EyeIcon"
                          :title="$t('setup.label.View')"
                          svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                          @click.stop="
                            $router.push({
                              name: 'View Property Master',
                              params: { id: PropertyMaster.id },
                            })
                          "
                          class="icon_row"
                        />
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('setup.label.Edit')"
                          svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                          @click.stop="
                            $router.push({
                              name: 'Edit Property Master',
                              params: { id: PropertyMaster.id },
                            })
                          "
                          class="icon_row"
                        />
                        <feather-icon
                          icon="TrashIcon"
                          :title="$t('setup.label.Delete')"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor"
                          @click.stop="
                            deletePropertyMasterPopup = true;
                            delMasterId = PropertyMaster.id;
                          "
                          class="icon_row"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="centerx">
                <vs-popup
                  classContent="popup-example"
                  :title="$t('setup.label.UploadPropertyData')"
                  :active.sync="editPropertyMasterPopup"
                  class="popup-close"
                >
                  <div class="vx-row w-full mb-6">
                    <div class="vx-col mb-2 mt-5 w-full form__container">
                      <label class="upload-label">
                        <img
                          src="@/assets/images/icons/Upload.svg"
                          alt="Upload Icon"
                          class="upload-icon"
                        />
                        <div class="upload-text">{{$t("setup.label.Browse_file_to_Upload")}}</div>
                      </label>
                    </div>
                  </div>
                  <div class="vx-row button-container">
                    <span class="button-spacing">
                      <vs-button
                        type="border"
                        @click="editPropertyMasterPopup = false"
                      >
                        {{ $t("setup.label.Cancel") }}
                      </vs-button>
                    </span>
                    <span class="button-spacing">
                      <vs-button @click="addUploadFile()">
                        {{ $t("setup.label.Save") }}
                      </vs-button>
                    </span>
                  </div>
                </vs-popup>
              </div>
            </vx-card>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
    <delete-popup
      :deletePopup="deletePropertyPopup"
      :title="$t('setup.label.Property')"
      @deletePressed="deleteProperty(delId)"
      @cancelPressed="deletePropertyPopup = false"
    >
    </delete-popup>
    <delete-popup
      :deletePopup="deletePropertyMasterPopup"
      :title="$t('setup.label.PropertyMaster')"
      @deletePressed="deletePropertyMaster(delMasterId)"
      @cancelPressed="deletePropertyMasterPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";
import vSelect from "vue-select";

export default {
  data() {
    return {
      loading: false,
      activeTab: 0,
      paginationItems: [5, 10, 15],
      deletePropertyPopup: false,
      deletePropertyMasterPopup: false,
      editJobsUomPopup: false,
      editPropertyMasterPopup: false,
    };
  },
  components: {
    "v-select": vSelect,
    AtomSpinner,
  },

  computed: {
    ...mapState({
      propertyListData: (state) => state.propertyDefinition.propertyList,
      propertyMasterListData: (state) =>
        state.propertyDefinition.propertyMasterList,
    }),
  },
  methods: {
    async getPropertyData() {
      try {
        await this.$store.dispatch("propertyDefinition/getPropertyListAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getPropertyMasterData() {
      try {
        await this.$store.dispatch(
          "propertyDefinition/getPropertyMasterListAction"
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteProperty(id) {
      try {
        this.deletePropertyPopup = false;
        await this.$store.dispatch(
          "propertyDefinition/deletePropertyAction",
          id
        );
        await this.getPropertyData();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deletePropertyMaster(id) {
      try {
        this.deletePropertyMasterPopup = false;
        await this.$store.dispatch(
          "propertyDefinition/deletePropertyMasterAction",
          id
        );
        await this.getPropertyMasterData();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  watch: {
    async activeTab(val) {
      this.loading = true;
      if (
        val === 0 &&
        !(this.propertyListData && this.propertyListData.pageItems)
      ) {
        await this.getPropertyData();
      } else if (
        val === 1 &&
        !(this.propertyMasterListData && this.propertyMasterListData.pageItems)
      ) {
        await this.getPropertyMasterData();
      }
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    await this.getPropertyData();
    this.loading = false;
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 50%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.under_input {
  width: 140px;
}
.form__container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.upload-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0.4rem;
}

.upload-icon {
  width: 40px;
  height: 40px;
}

.upload-text {
  margin-top: 0.4rem;
  font-size: 14px;
  color: #333;
}

.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}

.button-spacing {
  margin: 0 8px;
}
</style>
